export default __webpack_public_path__ + "static/media/animationtest2.cca4b60c.gif";